import { saveAs } from 'file-saver';
import { utils, write } from 'xlsx';


export abstract class ExportExcelComponent {

    constructor() {

    }

    // Generate the workbook and write the data to it.
    generateExcelFile(data): any {

        const sheetName = 'Sheet1';

        const workBook = {SheetNames: [], Sheets: {}};

        const ws: any = utils.json_to_sheet(data);

        workBook.SheetNames.push(sheetName);
        workBook.Sheets[sheetName] = ws;
        return write(workBook, {bookType: 'xlsx', type: 'binary'});
    }

    // Add the sheet data to array buffer.
    s2ab(s: any): ArrayBuffer {
        var buf = new ArrayBuffer(s.length);
        var view = new Uint8Array(buf);
        for (var i = 0; i != s.length; ++i)
            view[i] = s.charCodeAt(i) & 0xFF;
        return buf;
    }

    // Download the excel
    downloadExcel(data: any[], excelName: string): void {

        saveAs(new Blob([this.s2ab(this.generateExcelFile(data))], {type: "application/octet-stream"}), excelName + ".xlsx");
    }
}



// WEBPACK FOOTER //
// /home/forge/dev-client-app.instaveritas.com/releases/20231127121751/src/app/common/export-excel/export-excel.component.ts